export function ImgSideLeft() {
  return <img src="/static/img/side_left.svg" alt="Left" />;
}

export function ImgSideRight() {
  return <img src="/static/img/side_right.svg" alt="Rigth" />;
}
